module.exports = __webpack_public_path__ + "static/media/device_crowd_surf.c664e874.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/device_crowd_surf.svg
// module id = 1393
// module chunks = 0